import React, { useState } from 'react';
import { Formik, Form } from 'formik';

import * as Yup from 'yup';
import { makeStyles } from '@material-ui/core/styles';
import CustomeAlert from 'Components/Alert/Alert';
    import { Modal, Grid, Button, FormControl } from '@material-ui/core';

import { MaterialTextField } from 'Components/Inputes/FormikMaterialInput';

function getModalStyle() {
    const top = 50;
    const left = 50;

    return {
        top: `${top}%`,
        left: `${left}%`,
        transform: `translate(-${top}%, -${left}%)`
    };
}

const useStyles = makeStyles((theme) => ({
    login_form: {
        display: 'flex',
            flexDirection: 'column'
    },
    login_title: {
        marginTop: '20px',
        marginBottom: '-10px',
        fontSize: '20px',
        lineHeight: '1.2',
        textAlign: 'center',
        textTransform: 'none'
    },
    customButton: {
        marginTop: '2px',
        alignItems: 'right'
    },

    modalContent: {
        position: 'absolute',
        background: '#fff',
        padding: theme.spacing(2),
        borderRadius: '10px'
    }
}));

export function OTPModal({
    isOpen,
    error,
    title,
    submitCallback,
    resendCallback,
    onDismissCallback
}) {
    const classes = useStyles();

    const [modalStyle] = useState(getModalStyle);
    const [open, setOpen] = useState(isOpen);

    const [isError, setIsError] = useState(false);
    const [loading, setLoading] = useState(false);
    const [severity, setSeverity] = useState('success');

    var OTPObj = {
        OTP: ''
    };
    const OTPValidationSchema = Yup.object({
        OTP: Yup.string().required('Please enter valid OTP')
    });

    const handleModalClose = () => {
        setOpen(false);
        onDismissCallback(false);
    };

    const submithandle = async (values, { setSubmitting, resetForm }) => {
        setSubmitting(false);
        error = '';

        submitCallback(values);
        resetForm(OTPObj);
    };
    return (
        <Modal open={open} onClose={handleModalClose}>
            <div style={modalStyle} className={classes.modalContent}>
                {isError ? (
                    <Grid
                        item
                        xs={12}
                        sm={12}
                        md={12}
                        style={{ marginTop: '2em' }}
                    >
                        <CustomeAlert
                            message={error}
                            isOpen={isError}
                            severity={severity}
                            onCloseCallback={(AlertState) => {
                                setIsError(AlertState);
                            }}
                        />
                    </Grid>
                ) : null}

                <Formik
                    initialValues={OTPObj}
                    validationSchema={OTPValidationSchema}
                    onSubmit={submithandle}
                    resetForm={OTPObj}
                >
                    {(formProps) => {
                        return (
                            <Form className={classes.login_form}>
                                <FormControl className={classes.login_title}>
                                    {title}
                                </FormControl>
                                <Grid container spacing={4}>
                                    <Grid item xs={12} sm={12} md={12}>
                                        <label
                                            style={{
                                                color: 'red'
                                            }}
                                        >
                                            {error}
                                        </label>
                                    </Grid>

                                    <Grid item xs={12} sm={12} md={12}>
                                        <MaterialTextField
                                            label="OTP"
                                            name="OTP"
                                            type="text"
                                            length={10}
                                            placeholder="Enter OTP"
                                        />
                                    </Grid>

                                    <Grid item xs={12} sm={12} md={12}>
                                        <FormControl fullWidth>
                                            <Grid container spacing={2} style={{ marginTop: '6px' }}>
                                                <Grid
                                                    item
                                                    xs={12}
                                                    sm={12}
                                                    md={6}
                                                    lg={6}
                                                    xl={6}
                                                    style={{
                                                        marginTop: '6px'
                                                    }}
                                                >
                                                    <Button
                                                        variant="contained"
                                                        color="secondary"
                                                        onClick={handleModalClose}
                                                        fullWidth
                                                        style={{
                                                            height: '46px',
                                                            background: '#dddddd',
                                                            border: 'solid 1px',
                                                            borderColor: '#dddddd',
                                                            textTransform: 'none',
                                                            color: 'black',
                                                        }}
                                                    >
                                                        Close
                                                    </Button>

                                                </Grid>
                                                <Grid
                                                    item
                                                    xs={12}
                                                    sm={12}
                                                    md={6}
                                                    lg={6}
                                                    xl={6}
                                                    style={{
                                                        marginTop: '6px',
                                                        textTransform:
                                                            'none'
                                                    }}
                                                >
                                                    <Button
                                                        type="submit"
                                                        variant="contained"
                                                        color="primary"
                                                        disabled={loading}
                                                        fullWidth
                                                        style={{
                                                            height: '46px'
                                                        }}
                                                    >
                                                        Submit
                                                    </Button>
                                                </Grid>
                                            </Grid>
                                        </FormControl>
                                    </Grid>
                                </Grid>
                            </Form>
                        );
                    }}
                </Formik>
            </div>
        </Modal>
    );
}
